import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { updateOrderStepActionCreator } from 'app/pages/order/redux/action-creators/update-order-step-action-creator';
import { OrderStepService } from 'app/pages/order/services/order-step-service';
import { OrderStep } from 'app/pages/order/redux/model/order-step';

export const useGoToStep = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return (step: OrderStep, replacePath?: boolean) => {
        dispatch(updateOrderStepActionCreator(step));

        if (replacePath) {
            navigate(OrderStepService.getStepPath(step), { replace: true });
        } else {
            navigate(OrderStepService.getStepPath(step));
        }
    };
};
